import { TAttachment } from '@/models/chat.model';

import MessageAttachments from '../MessageAttachments/MessageAttachments';
import { StyledMessage } from './MessageStyles';

type TMessageProps = {
  message: string;
  attachments?: TAttachment[];
}

const Message = ({ message, attachments }: TMessageProps) => (
  <>
    <StyledMessage
      dangerouslySetInnerHTML={{
        __html: message
      }}
    />
    <MessageAttachments attachments={attachments} />
  </>
);

export default Message;
